import React from 'react';
import classnames from 'classnames';
import { getIconBaseUrl } from '../../utils/assets';
import { Button, Size, Theme } from '../Button';
import Popup from '../Popup';
import style from './Dialog.module.scss';
import Heading from '../Heading';
export var DialogTheme;
(function (DialogTheme) {
    DialogTheme["ERROR_THEME"] = "error";
    DialogTheme["INFO_THEME"] = "info";
    DialogTheme["SUCCESS_THEME"] = "success";
    DialogTheme["WARNING_THEME"] = "warning";
    DialogTheme["TIMEOUT_THEME"] = "timeout";
})(DialogTheme || (DialogTheme = {}));
const getIcon = (theme) => {
    switch (theme) {
        case DialogTheme.ERROR_THEME:
            return 'error.svg';
        case DialogTheme.SUCCESS_THEME:
            return 'check.svg';
        case DialogTheme.WARNING_THEME:
            return 'warning.svg';
        case DialogTheme.INFO_THEME:
            return 'info.svg';
        case DialogTheme.TIMEOUT_THEME:
            return 'timeout.svg';
        default:
            return null;
    }
};
export const Dialog = ({ title, content, onAccept, buttonLabel, onClose, theme }) => {
    const dialogStyles = classnames(style.dialog, {
        [style.dialogError]: theme === DialogTheme.ERROR_THEME,
        [style.dialogSuccess]: theme === DialogTheme.SUCCESS_THEME,
        [style.dialogInfo]: theme === DialogTheme.INFO_THEME,
        [style.dialogWarning]: theme === DialogTheme.WARNING_THEME,
        [style.dialogTimeout]: theme === DialogTheme.TIMEOUT_THEME,
    });
    const icon = getIcon(theme);
    return (<Popup onClose={onClose || (() => null)} className={dialogStyles} disableClose={!onClose}>
      {icon && <img src={getIconBaseUrl(icon)} alt={icon}/>}
      <Heading level={2} scale={2}>
        {title}
      </Heading>
      <div>{content}</div>
      <Button onClick={onAccept} theme={Theme.PRIMARY_THEME} scale={Size.LARGE_SIZE}>
        {buttonLabel}
      </Button>
    </Popup>);
};
export default Dialog;
